import Image from "next/image";
import Link from "next/link";
import AppLogo from "../../../../public/assets/img/app-logo.png";
import DashAppLogo from "../../../../public/assets/img/dash-app-logo.svg";
import InputForm from "../../../forms/InputForm";
import store from "store2";
import { useFormik } from "formik";
import { useQuery } from "react-query";
import { useRouter } from "next/router";
import HomeBookingSchema from "@/kyna/lib/validations/BookingSchema";
import { KTPost, KTGet } from "@/kyna/lib/db";
import NavigationBookingButton from "@/kyna/ui/button/NavigationBookingButton";
import { useState, useEffect } from "react";
import SlotFullModal from "./modules/SlotFullModal";
import KNModal from "@/kyna/ui/modal/KNModal";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
import toast from "react-hot-toast";
import { KNThemeError, KNThemeLoading } from "@/kyna/ui/toaster/KNTheme";

import KNDatePicker from "@/kyna/ui/datepicker";
const PatientTab = () => {
  const transaction_no = store.get("transaction_no");
  const [isSlotFullModalOpen, setIsSlotFullModalOpen] = useState(false);
  const router = useRouter();
  const { data, isLoading, status } = useQuery(["booking"], () =>
    KTGet("/api/booking/public", {
      where: `transaction_no:${transaction_no}`,
    })
  );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      sex: "",
      birthdate: "",
      email: "",
      contact_no: "",
      emergency_person_first_name: "",
      emergency_person_last_name: "",
      emergency_person_email: "",
      emergency_person_contact_no: "",
      citizenship: "",
    },
    validationSchema: HomeBookingSchema,
    onSubmit: async (values) => {
      toast.loading("Submitting...", {
        id: "submit-toast",
        ...KNThemeLoading,
      });
      const response = await KTPost(
        `/api/booking/public?transaction_no=${transaction_no}`,
        {
          ...values,
          birthdate: new Date(values.birthdate).toISOString(),
          contact_no: `+63${values.contact_no}`,
          emergency_person_contact_no: `+63${values.emergency_person_contact_no}`,
        }
      );
      if (response?.data?.success) {
        toast.dismiss("submit-toast");
        router.push("/booking/account");
      } else if (
        response?.error?.response?.status == 404 &&
        response?.error?.response?.data?.err == "Slot is full"
      ) {
        toast.dismiss("submit-toast");
        setIsSlotFullModalOpen(true);
      } else {
        toast.dismiss("submit-toast");
        toast.error("Error Occured, Please try again", {
          ...KNThemeError,
        });
      }
    },
  });
  const slotFull = () => {
    setIsSlotFullModalOpen(false);
    router.push("/booking");
  };
  useEffect(() => {
    formik.setValues({
      first_name: data?.data?.result?.first_name
        ? data?.data?.result?.first_name
        : "",
      last_name: data?.data?.result?.last_name
        ? data?.data?.result?.last_name
        : "",
      sex: data?.data?.result?.sex ? data?.data?.result?.sex : "",
      birthdate: data?.data?.result?.birthdate
        ? new Date(data?.data?.result?.birthdate)
        : "",
      email: data?.data?.result?.email ? data?.data?.result?.email : "",
      contact_no: data?.data?.result?.contact_no
        ? data?.data?.result?.contact_no?.substring(3)
        : "",
      citizenship: data?.data?.result?.citizenship
        ? data?.data?.result?.citizenship
        : "",
      emergency_person_first_name: data?.data?.result
        ?.emergency_person_first_name
        ? data?.data?.result?.emergency_person_first_name
        : "",
      emergency_person_last_name: data?.data?.result?.emergency_person_last_name
        ? data?.data?.result?.emergency_person_last_name
        : "",
      emergency_person_email: data?.data?.result?.emergency_person_email
        ? data?.data?.result?.emergency_person_email
        : "",
      emergency_person_contact_no: data?.data?.result
        ?.emergency_person_contact_no
        ? data?.data?.result?.emergency_person_contact_no?.substring(3)
        : "",
    });
  }, [data?.data?.result]);
  return (
    <>
      <section className="mx-auto">
        <div className="relative">
          <div className="relative md:fixed w-full md:w-5/12 h-full md:min-h-screen inset-0">
            <div className="bg-blue-500 h-full md:h-screen py-12 md:py-20 px-6 sm:px-14 md:px-10 lg:px-16 xl:px-20">
              <Link href="/">
                <a className="app-logo block w-full rounded-full max-w-[80px] md:max-w-[120px] h-[80px] md:h-[120px] bg-white p-2 md:p-3">
                  <Image src={AppLogo} alt="AppLogo" />
                </a>
              </Link>
              <div className="mt-8 md:mt-14">
                <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl leading-none mb-4 sm:mb-8">
                  We hope all is well!
                </h1>
                <p className="text-white text-lg md:text-xl lg:text-2xl leading-snug lg:leading-normal">
                  We are at the forefront of mental health advocacy for{" "}
                  <strong>
                    {new Date().getFullYear() -
                      new Date("January 15, 1950").getFullYear()}{" "}
                    years now
                  </strong>
                  , reaching out and changing millions of lives.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-7/12 ml-auto">
            <div className="pt-8 pb-20 px-6 sm:px-14 lg:px-16 max-w-4xl mx-auto">
              <div className="flex items-center justify-end flex-wrap gap-3 mb-10">
                <div className="form-group !mb-0">
                  <Link href="/">
                    <a className="btn btn-light-gray">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className="w-6 h-4 mr-2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                        />
                      </svg>
                      Back to home
                    </a>
                  </Link>
                </div>
                <div className="form-group !mb-0">
                  <Link href="/account/login/">
                    <a className="btn btn-primary">Login</a>
                  </Link>
                </div>
              </div>

              <h2 className="text-blue text-4xl sm:text-5xl leading-none">
                Book an appointment
              </h2>

              <p className="text-gray-600 text-lg md:text-xl lg:text-2xl leading-snug">
                We will continue to enhance individual and collective well-being
                for a mentally healthy Philippines!
              </p>

              <div className="mt-10"></div>

              <ul
                className="nav nav-tabs flex flex-row flex-wrap list-none border-b-0 pl-0"
                id="tabs-tab"
                role="tablist"
              >
                <Link href="/booking">
                  <li className="nav-item" role="presentation">
                    <span
                      className="
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-x-0 border-t-0 border-b-2 border-transparent
                        mr-8 sm:mr-14
                        hover:text-blue
                        focus:border-transparent
                        hover:border-b-blue hover:border-b-2
                        pb-4
                        cursor-pointer
                        "
                      id="tabs-booking-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#tabs-booking"
                      role="tab"
                      aria-controls="tabs-booking"
                      aria-selected="false"
                    >
                      Booking
                    </span>
                  </li>
                </Link>
                <Link href="/booking/patient">
                  <li className="nav-item" role="presentation">
                    <span
                      className="
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-b-2 border-blue
                        mr-8 sm:mr-14
                        hover:text-blue
                        focus:border-transparent
                        hover:border-b-blue hover:border-b-2
                        pb-4
                        cursor-pointer
                        "
                      id="tabs-patient-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#tabs-patient"
                      role="tab"
                      aria-controls="tabs-patient"
                      aria-selected="true"
                    >
                      Clients / Service Users
                    </span>
                  </li>
                </Link>
                <Link
                  href={
                    data?.data?.result?.first_name ? "/booking/account" : ""
                  }
                >
                  <li className="nav-item cursor-pointer" role="presentation">
                    <span
                      className={`
                        ${
                          data?.data?.result?.first_name
                            ? "hover:text-blue hover:border-b-blue hover:border-b-2"
                            : "cursor-not-allowed"
                        }
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-x-0 border-t-0 border-b-2 border-transparent
                        focus:border-transparent
                        pb-4
                        `}
                      id="tabs-account-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#tabs-account"
                      role="tab"
                      aria-controls="tabs-account"
                      aria-selected="false"
                    >
                      Account
                    </span>
                  </li>
                </Link>
              </ul>
              <div className="border-b border-gray-200 mb-10" />

              <div className="tab-content" id="tabs-tabContent">
                <div
                  className="tab-pane fade"
                  id="tabs-patient"
                  role="tabpanel"
                  aria-labelledby="tabs-patient-tab"
                >
                  <div className="tab-content-wrap">
                    <form onSubmit={formik.handleSubmit} autoComplete={"off"}>
                      <div className="grid grid-cols-2 gap-5">
                        <div className="col-span-1">
                          <InputForm
                            type="text"
                            label="First name*"
                            labelClassName="font-medium text-blue text-lg"
                            id="first_name"
                            name="first_name"
                            placeholder="Please enter your first name"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <InputForm
                            type="text"
                            label="Last name*"
                            labelClassName="font-medium text-blue text-lg"
                            id="last_name"
                            name="last_name"
                            placeholder="Please enter your last name"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <label
                            htmlFor="sex"
                            className="text-blue text-lg font-medium"
                          >
                            Gender*
                          </label>
                          <select
                            name="sex"
                            id="sex"
                            onChange={(e) => {
                              // handleChange(e)
                              formik.setFieldValue("sex", e.target.value);
                            }}
                            value={formik.values?.sex}
                            onBlur={formik.handleBlur}
                            className="w-full py-2 outline-none form-control"
                          >
                            <option value="">Select gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Non-binary">Non-binary</option>
                            <option value="Prefer not to say">
                              Prefer not to say
                            </option>
                          </select>
                          <div className="help-block text-red-400 text-xs mt-2">
                            {formik.touched.sex && formik.errors.sex && (
                              <div>{formik.errors.sex}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-span-1">
                          <label className="block">
                            {/* <span className="after:content-['*'] after:ml-0.5 after:text-red-500 mb-2 block text-lg font-semibold text-blue"> */}
                            <span className="block font-semibold text-blue text-lg">
                              Birthdate*
                            </span>
                            <div className="custom-fw-field">
                              <KNDatePicker
                                setDate={(date) => {
                                  formik.setFieldValue("birthdate", date);
                                }}
                                startDate={
                                  status === "success" &&
                                  data?.data?.result?.birthdate
                                    ? formik.values.birthdate
                                    : null
                                }
                                placeholderText="Enter your birthdate"
                              />
                            </div>
                          </label>
                          <div className="help-block text-red-400 text-xs mt-2">
                            {formik.touched.birthdate &&
                              formik.errors.birthdate && (
                                <div>{formik.errors.birthdate}</div>
                              )}
                          </div>
                        </div>
                        <div className="col-span-1">
                          <InputForm
                            type="email"
                            label="Email Address*"
                            labelClassName="font-medium text-blue text-lg"
                            id="email"
                            name="email"
                            placeholder="Please enter your email address"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="block" htmlFor="contact_no">
                            <span className="block font-medium text-blue text-lg">
                              Contact Number*
                            </span>
                            <div className="flex items-center">
                              <div className="form-control !w-16 mr-[10px] leading-7">
                                +63
                              </div>
                              <input
                                type="number"
                                id="contact_no"
                                name="contact_no"
                                className="form-control custom-number-field"
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "contact_no",
                                    e.target.value
                                  );
                                }}
                                value={formik.values?.contact_no}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </label>
                          <div className="help-block text-red-400 text-xs mt-2">
                            {formik.touched.contact_no &&
                              formik.errors.contact_no && (
                                <div>{formik.errors.contact_no}</div>
                              )}
                          </div>
                        </div>
                        <div className="col-span-1">
                          <InputForm
                            type="text"
                            label="Citizenship*"
                            labelClassName="font-medium text-blue text-lg"
                            id="citizenship"
                            name="citizenship"
                            placeholder="Filipino"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                      </div>

                      <div className="emergency-info border-t mt-10 py-4">
                        <p className="font-medium">
                          In case of emergency, please contact:
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-5">
                        <div className="col-span-1">
                          <InputForm
                            type="text"
                            label="First name*"
                            labelClassName="font-medium text-blue text-lg"
                            id="emergency_person_first_name"
                            name="emergency_person_first_name"
                            placeholder="Please enter your first name"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <InputForm
                            type="text"
                            label="Last name*"
                            labelClassName="font-medium text-blue text-lg"
                            id="emergency_person_last_name"
                            name="emergency_person_last_name"
                            placeholder="Please enter your last name"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <InputForm
                            type="email"
                            label="Email Address*"
                            labelClassName="font-medium text-blue text-lg"
                            id="emergency_person_email"
                            name="emergency_person_email"
                            placeholder="Please enter your email address"
                            withFormik={true}
                            formik={formik}
                          />
                        </div>
                        <div className="col-span-1">
                          <label
                            className="block"
                            htmlFor="emergency_person_contact_no"
                          >
                            <span className="block font-medium text-blue text-lg">
                              Contact Number*
                            </span>
                            <div className="flex items-center">
                              <div className="form-control !w-16 mr-[10px] leading-7">
                                +63
                              </div>
                              <input
                                type="number"
                                id="emergency_person_contact_no"
                                name="emergency_person_contact_no"
                                className="form-control custom-number-field"
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "emergency_person_contact_no",
                                    e.target.value
                                  );
                                }}
                                value={
                                  formik.values?.emergency_person_contact_no
                                }
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </label>
                          <div className="help-block text-red-400 text-xs mt-2">
                            {formik.touched.emergency_person_contact_no &&
                              formik.errors.emergency_person_contact_no && (
                                <div>
                                  {formik.errors.emergency_person_contact_no}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between items-center mt-10">
                        <NavigationBookingButton
                          className={"rotate-180"}
                          onClick={() => {
                            router.push("/booking");
                          }}
                        />
                        <NavigationBookingButton type={"submit"} />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <KNModal
        isOpen={isSlotFullModalOpen}
        noFooter={true}
        bodyClass={"max-w-4xl mt-10"}
        closeModal={slotFull}
        body={<SlotFullModal slotFull={slotFull} />}
      />
      <KNToaster />
    </>
  );
};

export default PatientTab;
